<template>
  <tr class="operative-table-body-header">
    <th><slot></slot></th>
    <th v-if="withTotal">Totale</th>
    <template v-for="(value, i) in years">
      <th class="operative-table-value-column-header" :class="{ 'text-left': align === 'left', 'text-center': align === 'center', 'text-right': align === 'right' }" :key="'header-' + i">
        <template v-if="showYears"><slot name="value" :value="value">{{ value }}</slot></template>
        <span v-else>&nbsp;</span>
      </th>
    </template>
  </tr>
</template>

<script>

export default {
  props: {
    years: {
      type: Array,
      default: () => [],
    },
    showYears: {
      type: Boolean,
      default: false,
    },
    withTotal: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'default',
    },
  },
};

</script>

<style lang="scss">

$primary: blue !default;

.operative-table-body-header {
  th {
    background: $primary;
    color: white;
    text-transform: uppercase;

    &:first-child {
      min-width: 250px;
      max-width: 300px;

      @include media-breakpoint-up("md") {
        min-width: 300px;
        max-width: 600px;
      }
    }
  }

  .operative-table-value-column-header {
    text-align: right;
  }
}

</style>
